import { FormEvent, useEffect, useState } from "react";
import I18n from "common/i18n";
import Constants from "common/constant";
import { usePlaySound } from "common/utils";
import { InScreenModal } from "./ScreenModal";
import { SparkleBurst } from "./SparkleBurst";
import { BuilderModalPanel, BuilderModalAccent } from "./BuilderModalPanel";
import { PillSize, PillColor, BuilderPillButton } from "./BuilderPillButton";

const MAX = 20;

export const CreateMapModal = ({
  visible,
  defaultName,
  close,
  onCreate,
}: {
  visible: boolean;
  defaultName: string;
  close: () => void;
  onCreate: (name: string) => void;
}) => {
  const playCreate = usePlaySound(`${Constants.assetHost}/assets/blockly/start.mp3`);
  const [name, setName] = useState(defaultName);
  const [celebrate, setCelebrate] = useState(false);

  // 開くたびに既定名へリセット
  useEffect(() => {
    if (visible) {
      setName(defaultName);
      setCelebrate(false);
    }
  }, [visible, defaultName]);

  const over = name.length > MAX;
  const invalid = name.trim().length === 0 || over;

  const handleSubmit = (event: FormEvent<HTMLFormElement>) => {
    event.preventDefault();
    if (invalid) return;
    playCreate();
    setCelebrate(true);
    onCreate(name.trim());
  };

  return (
    <InScreenModal open={visible} onBackdropClose={name.trim() ? undefined : close}>
      <BuilderModalPanel
        accent={BuilderModalAccent.GREEN}
        icon="map"
        title={I18n.t("MSG_BUILDER_NEW_MAP_TITLE")}
        width={440}
      >
        {celebrate && <SparkleBurst />}

        <p className="type-text-left type-body text-textcolor-black/60">
          {I18n.t("MSG_BUILDER_MAP_NAME_PLACEHOLDER")}
        </p>

        <form onSubmit={handleSubmit} className="flex-col-el w-full gap-2">
          <input
            type="text"
            name="name"
            value={name}
            autoFocus={false}
            onChange={(e) => setName(e.target.value)}
            className="type-text type-body text-textcolor-black w-full box-border px-3 py-2 rounded-xl bg-white border-2 border-solid border-gray2-30 outline-none focus:border-green-100 focus:ring-4 focus:ring-green-100/30"
          />
          <div className="flex-row-el items-center justify-between w-full h-6 px-1">
            <p className="type-text-left type-sm text-danger">
              {over ? I18n.t("MSG_BLOCKLY_INPUT_LENGTH_LIMIT", { limit: MAX }) : ""}
            </p>
            <p className="type-text type-sm text-textcolor-black/40">{`${name.length} / ${MAX}`}</p>
          </div>

          <div className="flex-row-el flex-center w-full gap-4 pb-2">
            <BuilderPillButton
              color={PillColor.BLUE}
              size={PillSize.MD}
              icon="close"
              label={I18n.t("MSG_STOP_BTN")}
              onClick={close}
            />
            <BuilderPillButton
              type="submit"
              color={PillColor.GREEN}
              size={PillSize.MD}
              icon="check"
              label={I18n.t("MSG_CONFIRM_BTN")}
              disabled={invalid}
            />
          </div>
        </form>
      </BuilderModalPanel>
    </InScreenModal>
  );
};
